webpackJsonp([11],{

/***/ 389:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__article__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_style_scss__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_style_scss__);
/*! Based on MultiLevelMenu | Copyright 2015, Codrops http://www.codrops.com | http://www.opensource.org/licenses/mit-license.php */
// import _ from 'lodash';



// const supportsAnimations = document.createElement('div').style.animationName !== undefined;

// function onAnimationEnd(element, callback) {
//   function onEnd(event) {
//     if (event.target === this) {
//       this.removeEventListener('animationend', onEnd);
//       callback();
//     }
//   }
//   if (supportsAnimations) {
//     element.addEventListener('animationend', onEnd);
//   } else {
//     setTimeout(callback, 10);
//   }
// }

// const defaultOptions = {
//   breadcrumbs: false,
//   initialBreadcrumb: 'all',
//   backButton: false,
//   itemsDelayInterval: 60,
//   direction: 'r2l',
//   // called when an item that doesn't have a submenu gets clicked
//   // onItemClick([event], [inner HTML of the clicked item])
//   onItemClick: () => { },
// };

// class MLMenu {
//   constructor(element, options) {
//     this.element = element || document.createElement('div');
//     this.options = _.assign({}, defaultOptions, options);
//     this.menuElements = Array.prototype.slice.call(this.element.querySelectorAll('.menu__level'));
//     this.current = 0;
//     this.initElements();
//     this.initEvents();
//   }

//   initElements() {
//     this.menus = this.menuElements.map((element) => {
//       const menuID = element.getAttribute('data-menu');
//       const link = this.element.querySelector(`[data-submenu="${menuID}"]`);
//       return {
//         element,
//         items: Array.prototype.slice.call(element.querySelectorAll('.menu__item')),
//         label: link ? link.textContent.trim() : '??',
//         name: menuID,
//         parentIndex: link ? this.menuElements.indexOf(link.parentElement) : -1,
//       };
//     });

//     if (this.options.backButton) {
//       this.backButton = document.createElement('button');
//       this.backButton.className = 'menu__back menu__back--hidden';
//       this.backButton.setAttribute('aria-label', 'Go back');
//       this.backButton.innerHTML = '<span></span>';
//       this.element.insertBefore(this.backButton, this.element.firstChild);
//     }

//     if (this.options.breadcrumbs) {
//       this.breadcrumbs = document.createElement('nav');
//       this.breadcrumbs.className = 'menu__breadcrumbs';
//       this.element.insertBefore(this.breadcrumbs, this.element.firstChild);
//       // add initial breadcrumb
//       this.addBreadcrumb(0);
//     }

//     if (!this.element.querySelector('.menu__item[data-active]') && !this.element.querySelector('.menu__item[data-active-parent]')) {
//       let urlPath = window.location.pathname;
//       while (urlPath.length > 1) {
//         const lastSlash = urlPath.lastIndexOf('/', urlPath.length - 2);
//         if (lastSlash === -1) {
//           break;
//         }
//         urlPath = urlPath.slice(0, lastSlash + 1);
//         if (urlPath.length <= 1) {
//           break;
//         }
//         const links = this.element.querySelectorAll(`a.menu__link[href="${urlPath}"]`);
//         if (links && links.length) {
//           const anchor = links[links.length - 1];
//           anchor.parentElement.setAttribute('data-active', 'true');
//         }
//       }
//     }

//     const found = this.menus.some((menu, menuIndex) => (
//       menu.items.some((item, j) => {
//         const isActive = item.hasAttribute('data-active');
//         const isActiveParent = item.hasAttribute('data-active-parent');
//         if (isActive || isActiveParent) {
//           this.current = menuIndex;
//           menu.element.classList.add('menu__level--current');
//           const anchor = item.querySelector('.menu__link');
//           if (anchor) {
//             if (isActive) {
//               anchor.classList.add('menu__link--current');
//             }
//             if (isActiveParent) {
//               anchor.classList.add('menu__link--currentparent');
//             }
//           }
//           this.buildBreadCrumbs(menu, []);
//           if (this.options.backButton && menuIndex > 0) {
//             this.backButton.classList.remove('menu__back--hidden');
//           }

//           const subMenu = item.getAttribute('data-submenu');
//           if (subMenu) {
//             const subMenuElement = this.element.querySelector(`ul[data-menu="${subMenu}"]`);
//             if (subMenuElement) {
//               this.openSubMenu(subMenuElement, j);
//             }
//           }
//           return true;
//         }
//         return false;
//       })
//     ));

//     if (!found && this.menus.length > 0) {
//       this.menus[0].element.classList.add('menu__level--current');
//     }
//   }

//   buildBreadCrumbs(menu, list) {
//     if (menu.name) {
//       if (menu.parentIndex !== -1) {
//         list.unshift(menu);
//         this.buildBreadCrumbs(this.menus[menu.parentIndex], list);
//       } else {
//         list.forEach((e) => {
//           this.addBreadcrumb(this.menus.indexOf(e));
//         });
//       }
//     }
//   }

//   initEvents() {
//     this.menus.forEach((menu) => {
//       menu.items.forEach((item, j) => {
//         const anchor = item.querySelector('.menu__link');
//         if (anchor) {
//           anchor.addEventListener('click', (event) => {
//             const subMenu = event.target.parentElement.getAttribute('data-submenu');
//             if (subMenu) {
//               const href = event.target.getAttribute('href');
//               const hasGroup = event.target.parentElement.hasAttribute('data-group');
//               if (hasGroup || href === '' || href === '#') {
//                 event.preventDefault();
//               }
//               const subMenuElement = this.element.querySelector(`ul[data-menu="${subMenu}"]`);
//               if (subMenuElement) {
//                 // this.openSubMenu(subMenuElement, j);
//               }
//             } else {
//               const oldCurrent = this.element.querySelector('.menu__link--current');
//               if (oldCurrent) {
//                 oldCurrent.classList.remove('menu__link--current');
//                 oldCurrent.classList.remove('menu__link--currentparent');
//               }
//               event.target.classList.add('menu__link--current');
//               this.options.onItemClick(event);
//             }
//           });
//         }
//       });
//     });

//     if (this.options.backButton) {
//       this.backButton.addEventListener('click', () => {
//         this.back();
//       });
//     }

//     // // mobile menu toggle
//     // const actionOpen = document.querySelector('.menu-action--open');
//     // if (actionOpen) {
//     //   actionOpen.addEventListener('click', () => {
//     //     this.element.classList.add('menu--open');
//     //     const scroller = document.scrollingElement || document.documentElement;
//     //     scroller.style.overflow = 'hidden';
//     //   });
//     // }

//     // const actionClose = document.querySelector('.menu-action--close');
//     // if (actionClose) {
//     //   actionClose.addEventListener('click', () => {
//     //     this.element.classList.remove('menu--open');
//     //     const scroller = document.scrollingElement || document.documentElement;
//     //     scroller.style.overflow = '';
//     //   });
//     // }
//   }

//   openSubMenu(subMenuElement, clickPosition) {
//     if (!this.isAnimating) {
//       this.isAnimating = true;

//       // current menu slides out
//       this.menuOut(clickPosition);
//       // next menu (submenu) slides in
//       this.menuIn(subMenuElement, clickPosition);
//     }
//   }

//   back() {
//     const backMenu = this.menus[this.menus[this.current].parentIndex].element;
//     this.openSubMenu(backMenu);
//   }

//   menuOut(clickPosition) {
//     const isBackNavigation = typeof clickPosition === 'undefined';
//     const currentMenuElement = this.menus[this.current].element;

//     // slide out current menu items - first, set the delays for the items
//     this.menus[this.current].items.forEach((item, i) => {
//       const delay = (isBackNavigation ? i : Math.abs(clickPosition - i));
//       item.style.animationDelay = `${delay * this.options.itemsDelayInterval}ms`;
//     });

//     const isLeftToRight = this.options.direction === 'r2l';
//     if (isLeftToRight === isBackNavigation) {
//       currentMenuElement.classList.add('animate-outToRight');
//     } else {
//       currentMenuElement.classList.add('animate-outToLeft');
//     }
//   }

//   menuIn(nextMenuElement, clickPosition, callback) {
//     const isBackNavigation = typeof clickPosition === 'undefined';
//     const currentMenuElement = this.menus[this.current].element;
//     const nextMenuIndex = this.menuElements.indexOf(nextMenuElement);
//     const nextMenuItems = this.menus[nextMenuIndex].items;

//     // we need to reset the classes once the last item animates in
//     // the "last item" is the farthest from the clicked item
//     // let's calculate the index of the farthest item
//     const isTopHalf = clickPosition <= nextMenuItems.length / 2;
//     const farthestIndex = (isBackNavigation || isTopHalf) ? nextMenuItems.length - 1 : 0;

//     // slide in next menu items - first, set the delays for the items
//     nextMenuItems.forEach((item, i) => {
//       const delay = (isBackNavigation ? i : Math.abs(clickPosition - i));
//       item.style.animationDelay = `${delay * this.options.itemsDelayInterval}ms`;

//       if (i === farthestIndex) {
//         onAnimationEnd(item, () => {
//           currentMenuElement.classList.remove('animate-outToLeft');
//           currentMenuElement.classList.remove('animate-outToRight');
//           nextMenuElement.classList.remove('animate-inFromRight');
//           nextMenuElement.classList.remove('animate-inFromLeft');

//           currentMenuElement.classList.remove('menu__level--current');
//           nextMenuElement.classList.add('menu__level--current');
//           this.current = nextMenuIndex;

//           const addClassesToNewCurrentItem = (newItem) => {
//             const oldCurrent = this.element.querySelector('.menu__link--current');
//             if (oldCurrent) {
//               oldCurrent.classList.remove('menu__link--current');
//               oldCurrent.classList.remove('menu__link--currentparent');
//             }
//             const anchor = newItem.querySelector('.menu__link');
//             if (anchor) {
//               anchor.classList.add('menu__link--current');
//             }
//           };

//           this.menus[nextMenuIndex].items.some((newItem) => {
//             if (isBackNavigation) {
//               if (newItem.getAttribute('data-submenu') === currentMenuElement.getAttribute('data-menu')) {
//                 addClassesToNewCurrentItem(newItem);
//                 return true;
//               }
//             } else if (newItem.hasAttribute('data-parent')) {
//               addClassesToNewCurrentItem(newItem);
//               return true;
//             }
//             return false;
//           });

//           if (!isBackNavigation) {
//             if (this.options.backButton) {
//               this.backButton.classList.remove('menu__back--hidden');
//             }
//             this.addBreadcrumb(nextMenuIndex);
//           } else {
//             if (this.options.breadcrumbs) {
//               this.breadcrumbs.removeChild(this.breadcrumbs.lastElementChild);
//             }
//             if (this.current === 0 && this.options.backButton) {
//               this.backButton.classList.add('menu__back--hidden');
//             }
//           }

//           this.isAnimating = false;

//           if (callback) {
//             callback();
//           }
//         });
//       }
//     });

//     const isLeftToRight = this.options.direction === 'r2l';
//     if (isLeftToRight === isBackNavigation) {
//       nextMenuElement.classList.add('animate-inFromLeft');
//     } else {
//       nextMenuElement.classList.add('animate-inFromRight');
//     }
//   }

//   addBreadcrumb(index) {
//     if (this.options.breadcrumbs) {
//       const crumb = document.createElement('a');
//       crumb.textContent = index ? this.menus[index].label : this.options.initialBreadcrumb;
//       this.breadcrumbs.appendChild(crumb);

//       crumb.addEventListener('click', (event) => {
//         event.preventDefault();

//         // if not the last one and not currently animating
//         if (crumb.nextSibling && !this.isAnimating) {
//           this.isAnimating = true;

//           this.menuOut();
//           this.menuIn(this.menus[index].element, undefined, () => {
//             // remove breadcrumbs that are ahead
//             let siblingNode = crumb.nextSibling;
//             while (siblingNode) {
//               this.breadcrumbs.removeChild(siblingNode);
//               siblingNode = crumb.nextSibling;
//             }
//           });
//         }
//       });
//     }
//   }
// }

// const menuEl = document.getElementById('ml-menu');

// window.mlmenu = new MLMenu(menuEl, {
//   initialBreadcrumb: 'cnvos',
// });

/***/ }),

/***/ 390:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_js_tooltip__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_js_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bootstrap_js_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_js_transition__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_js_transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap_js_transition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_js_collapse__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_js_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap_js_collapse__);





__WEBPACK_IMPORTED_MODULE_0_jquery___default()('[data-toggle="tooltip"]').tooltip({
  container: 'body'
});

__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.bootstrap-accordion-title').each(function fixCollapsedClass() {
  var $this = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
  var $body = $this.closest('.panel').find('.panel-collapse.collapse');
  $this.toggleClass('collapsed', !$body.hasClass('in'));
});

__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.accordion-parent').on('show.bs.collapse', '.panel', function onShown() {
  var $panel = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).closest('.panel');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').animate({
    scrollTop: $panel.offset().top
  }, {
    duration: 350,
    step: function step(now, tween) {
      tween.end = $panel.offset().top;
    }
  });
});

// FIX FOR HEADER HIERARCHY
(function accordionFix() {
  // fix nested accordions due to editor bug
  var $panels = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.accordion-parent > .bootstrap-accordion > .bootstrap-accordion');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.each($panels, function (i, panel) {
    var $panel = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(panel);
    $panel.parent().parent().append($panel);
  });

  function fixAccordionHeading() {
    var $h3 = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<h3>', {
      html: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).html(),
      class: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('class')
    });

    // Copy all data attributes
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.each(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data(), function (key, value) {
      $h3.attr('data-' + key, value);
    });

    return $h3;
  }

  function fixAccordionButton() {
    var $button = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<button>', {
      html: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).html(),
      class: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('class')
    });

    // Copy all data attributes
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.each(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data(), function (key, value) {
      $button.attr('data-' + key, value);
    });
    // Copy href to data-target
    $button.attr('data-target', __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('href'));

    return $button;
  }

  // fix all existing accordions
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.accordion-parent .panel-heading h4').replaceWith(fixAccordionHeading);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.accordion-parent .panel-heading h3 a').replaceWith(fixAccordionButton);

  // observe for new accordions
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      // some accordions are added dynamically and if they have the "collapsing" class
      // are not initialized yet, so wait until they are

      if (mutation.type === 'childList') {
        var $addedNodes = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(mutation.addedNodes);
        var $accordions = $addedNodes.find('.accordion-parent .panel-heading h4');
        if ($accordions.length) {
          $accordions.find('a').each(function eachClass() {
            var cls = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('class').split(/\s+/);
            if (!cls.includes('collapsing')) {
              __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parent().replaceWith(fixAccordionHeading);
            }
          });
        }
        var $accordionButtons = $addedNodes.find('.accordion-parent .panel-heading a');
        if ($accordionButtons.length) {
          $accordionButtons.each(function eachClass() {
            var cls = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('class').split(/\s+/);
            if (!cls.includes('collapsing')) {
              __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).replaceWith(fixAccordionButton);
            }
          });
        }
      }
      if (mutation.type === 'attributes') {
        if (mutation.target.matches('.accordion-parent .panel-heading h4 a')) {
          var cls = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(mutation.target).attr('class').split(/\s+/);
          if (!cls.includes('collapsing')) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(mutation.target).parent().replaceWith(fixAccordionHeading);
            requestAnimationFrame(function () {
              __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.accordion-parent .panel-heading h3 a').replaceWith(fixAccordionButton);
            });
          }
        }
      }
    });
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true });
})();

// FIX FOR LANDING BOX HOVER ANIMATION
(function fixLandingBoxHeaderHover() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.landing-box .caption h2, .landing-box .caption h3, .landing-box .caption h4, .document').each(function wrapSpan() {
    // wrap in a span
    var $this = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    var $span = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<span>', {
      html: $this.html()
    });
    $this.empty();
    $this.append($span);
  });
})();

// replace old iframe chart embed urls
// (this only happens if page/chart was not edited since new urls were introduced)
__WEBPACK_IMPORTED_MODULE_0_jquery___default()('iframe[src^="https://danesjenovdan.si/grafi/embed.html"]').each(function eachFrame() {
  this.src = this.src.replace('https://danesjenovdan.si/grafi/embed.html', '/charts/embed.html');
});
__WEBPACK_IMPORTED_MODULE_0_jquery___default()('iframe[src^="https://other.lb.djnd.si/grafi/embed.html"]').each(function eachFrame() {
  this.src = this.src.replace('https://other.lb.djnd.si/grafi/embed.html', '/charts/embed.html');
});

// add title to chart iframes for accessibility
__WEBPACK_IMPORTED_MODULE_0_jquery___default()('iframe[src*="charts/embed.html"]').each(function eachFrame() {
  if (!this.title) {
    this.title = 'Grafikon';
  }
});

/***/ }),

/***/ 391:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[389]);


// WEBPACK FOOTER //
// js/multilevelmenu.bf10c35099d635d308f3.js